
document.addEventListener('DOMContentLoaded', function() {
    const submenuItems = document.querySelectorAll('.submenu-item a'); // Target links in submenus
    let foundCurrent = false;
    let nextCategory = null;

    // Loop to identify the current category and find the next
    submenuItems.forEach((item, index) => {
        if (window.location.href.includes(item.href)) {
            foundCurrent = true; // Current category found
        } else if (foundCurrent && !nextCategory) {
            nextCategory = item; // Next category is set here
            return; // Stop the loop once next category is found
        }
    });

    // Display only the next category if found
    if (nextCategory) {
        const menuContainer = document.getElementById('dynamic-menu');
        menuContainer.style.display = 'block'; // Enable the menu container display
        menuContainer.innerHTML = ''; // Clear existing menu items
        
        const nextCategoryLink = document.createElement('div');
        nextCategoryLink.className = 'next-category';
        nextCategoryLink.innerHTML = `<span>Next: </span><a href="${nextCategory.href}">${nextCategory.textContent}</a>`;
        menuContainer.appendChild(nextCategoryLink);
    }
});

